module.exports = __webpack_public_path__ + "static/media/DiscordLogoDark.b7a9ce99.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/DiscordLogoDark.svg
// module id = 1156
// module chunks = 0